import { color, fontTypeToObject } from '@starrez/starrytheme';
import { Icons, Icon } from '@starrez/starryui';
import React from 'react';
import styled from 'styled-components';
import { useSearch } from './useSearch';

export interface ISearchInputProps {
    onSearchChange: (search: string) => Promise<void>;
    placeholder: string;
    searchAriaLabel: string;
    clearAriaLabel: string;
}

export const SearchInput = ({ onSearchChange, placeholder, searchAriaLabel, clearAriaLabel }: ISearchInputProps) => {
    const { cancelButton, input, searchButton, ref, hasSearch } = useSearch({
        onSearch: (searchString) => onSearchChange(searchString),
        placeholder,
        searchAriaLabel,
        clearAriaLabel,
    });

    return (
        <SearchWrapper hasSearch={hasSearch} ref={ref}>
            <Input hasSearch={hasSearch} {...input} />
            {hasSearch && (
                <Button {...cancelButton}>
                    <Icon Icon={Icons.CloseThick} />
                </Button>
            )}
            <Button {...searchButton}>
                <Icon Icon={Icons.Search} />
            </Button>
        </SearchWrapper>
    );
};

const Button = styled.button`
    border: 2px solid transparent;
    border-radius: 4px;
    background-color: transparent;
    color: ${color.Grey.G70};
    cursor: pointer;

    > * {
        cursor: pointer;
    }

    &:hover {
        background-color: ${color.Blue.B20};
        color: ${color.Blue.B60};
    }

    &:focus {
        border: 2px solid ${color.Blue.B80};
        outline: none;
    }
`;

const Input = styled.input<{ hasSearch: boolean }>`
    &::-webkit-search-cancel-button {
        -webkit-appearance: none;
    }

    &:focus {
        outline: none;
        border: 2px solid ${color.Blue.B80};
    }

    border: 2px solid transparent;
    background-color: transparent;
    border-radius: 4px;
    text-indent: 8px;
    color: ${color.Grey.G70};
    padding-right: ${(props) => (props.hasSearch ? '0' : '40px')};

    ${(_) => ({ ...fontTypeToObject('normal.regular') })}
`;

const SearchWrapper = styled.div<{ hasSearch: boolean }>`
    height: 40px;
    border-radius: 4px;
    background-color: ${color.Grey.G10};
    overflow: hidden;
    display: grid;
    grid-template-columns: ${(props) => (props.hasSearch ? '1fr 40px 40px' : '1fr 40px')};
    border: 2px solid ${color.Grey.G10};
`;
